

























import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { State, Getter, namespace } from "vuex-class";
import RegistrationForm from "@/components/authentication/RegistrationForm.vue";
import RegistrationSuccess from "@/components/authentication/RegistrationSuccess.vue";
import UserAlert from "@/components/UserAlert.vue";

const UserModule = namespace("userModule");

@Component({
  components: {
    RegistrationForm,
    RegistrationSuccess,
    UserAlert
  }
})
export default class RegistrationPage extends Vue {
  @UserModule.Getter public hasRegistered: boolean;

  @Provide() public isRegistrationCompleted: boolean = false;

  get getHasRegistered() {
    return this.hasRegistered;
  }

  @Watch("getHasRegistered")
  public onRegisteredChanged(val: boolean, oldVal: boolean) {
    if (oldVal !== true) {
      this.isRegistrationCompleted = val;
    }
  }
}
